import type { State } from '../../types';
import type { CompetenceViewModel } from '@trinnvis/dabih-api-client';
import { currentEmployeeUuid } from './current-employee-uuid';
import { competenceNotDeleted } from '../documents/competence-not-deleted';
import type { ListSectionItemInput } from '../../../library/lists/listSectionItemInput';
import { getListSectionMainIcon } from 'src/store/selectors/get-list-section-main-icon';
import { sortedByLabel } from 'src/store/utilities';
import { t } from 'src/i18n';

function secondaryLabelFor(c: CompetenceViewModel): string {
  if (c.type === 'CERTIFICATE') {
    if (!c.expiryDate) return '';
    if (c.status === 'EXPIRED') return t('competence.listLabel.expiredOn', { date: c.expiryDate });
    if (c.status === 'EXPIRING_SOON') return t('competence.listLabel.expiresOn', { date: c.expiryDate });
    return t('competence.listLabel.validUntil', { date: c.expiryDate });
  }
  return c.completedDate ? t('competence.listLabel.completedOn', { date: c.completedDate }) : '';
}

export function employeeCompetenceAsListItems(state: State, href: string, uuid: string): ListSectionItemInput[] {
  const current = currentEmployeeUuid(state);
  const items = competenceNotDeleted(state)
    .filter((c) => c.employeeUuid === uuid)
    .map((c) => {
      let moreref = '/competence/' + c.uuid;
      if (!c.isConfirmedEntity || !c.name) {
        moreref += '?edit';
      }
      return {
        href: href + moreref,
        label: c.name ?? '',
        secondaryLabel: secondaryLabelFor(c),
        mainIcon: getListSectionMainIcon('competence', false, c.classification, undefined, c.status),
        accessible: c.classification === 'NONE' || (current !== undefined && (c.accessControl ?? []).includes(current)),
        hasDraft: c.hasDraft,
      };
    });
  return sortedByLabel(items);
}
